import React from 'react';
import {Route, Switch, Redirect} from "react-router";
import PzbadSignatureContainer from "./Container/PzbadSignatureContainer";
import {connect} from "react-redux";
import ABRMSignatureContainer from "./Container/ABRMSignatureContainer";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {
};

class App extends React.Component {

    render() {
        return (
            <Switch history={this.props.history}>
                <Route path="/signature/abrm" component={ABRMSignatureContainer}/>
                <Route path="/signature" component={PzbadSignatureContainer}/>
                <Redirect from="/" to="/signature"/>
            </Switch>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// src/App.js